import { currentLang } from "@/i18n";
import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });
api.interceptors.request.use((config) => {
  if (config.method === "get" && /^\/(catalog|payments\/packs)/.test(config.url || "")) config.params = { ...config.params, lang: currentLang() };
  return config;
});

let refreshing = null;
const NO_RETRY = ["/auth/refresh", "/auth/login", "/auth/register", "/auth/logout"];

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const orig = err.config || {};
    if (err.response?.status === 401 && !orig._retry && !NO_RETRY.some((p) => orig.url?.includes(p))) {
      orig._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => (refreshing = null));
      try {
        await refreshing;
        return api(orig);
      } catch {
        return Promise.reject(err);
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  if (typeof detail.message === "string") return detail.message;
  return String(detail);
}

export const pageImageUrl = (id) => `${API}/pages/${id}/image`;
export const artworkImageUrl = (id) => `${API}/artworks/${id}/image`;

async function blobUrl(path) {
  const r = await api.get(path, { responseType: "blob" });
  return URL.createObjectURL(r.data);
}

export async function downloadFile(path, filename) {
  const url = await blobUrl(path);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}

export async function openPrint(path) {
  const w = window.open("", "_blank");
  const url = await blobUrl(path);
  if (w) w.location.href = url;
  else window.location.href = url;
}

export const slug = (s) => (s || "page").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export function printImage(src, title) {
  const w = window.open("", "_blank");
  if (!w) return;
  const d = w.document;
  d.title = title || "Picture";
  const style = d.createElement("style");
  style.textContent = "body{margin:0;display:flex;align-items:center;justify-content:center;min-height:100vh}img{max-width:100%;max-height:100vh}";
  d.head.appendChild(style);
  const img = d.createElement("img");
  img.alt = "";
  img.onload = () => setTimeout(() => w.print(), 150);
  img.src = src;
  d.body.appendChild(img);
}
